





























































import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';
import i18n from '../footnotes/i18n';

const IconFuelConsumption = () => import('../../common/icons/fuel-consumption.svg');
const IconFuelPollution = () => import('../../common/icons/pollution.svg');
const IconEnergyConsumption = () => import('../../common/icons/energy-consumption.svg');
const IconGasUpdated = () => import('../../common/icons/gas-updated.svg');
const IconEnergyUpdated = () => import('../../common/icons/energy-updated.svg');
const IconCo2Updated = () => import('../../common/icons/co2-updated.svg');

export interface LabelingInfo {
  modelName: string | null;
  testProcedure: string | null;
  fuelConsumption: string | null;
  fuelPollution: string | null;
  energyConsumption: string | null;
  labelingText: string | null;
}

const Co2LabelingProps = Vue.extend({
  props: {
    labelingJson: String,
    modelName: String,
    testProcedure: String,
    fuelConsumption: String,
    fuelPollution: String,
    energyConsumption: String,
    labelingText: String,
    layoutVariant: {
      type: String,
      default: 'icons-legacy',
      validator: (val: string) => ['icons-legacy', 'icons', 'text', 'text-large'].includes(val),
    },
  },
});

@Component({
  components: {
    IconFuelConsumption,
    IconFuelPollution,
    IconEnergyConsumption,
    IconGasUpdated,
    IconEnergyUpdated,
    IconCo2Updated,
  },
  i18n,
})
export default class Co2Labeling extends mixins(Co2LabelingProps) {
  get rootClasses () {
    return {
      'brandhub-co2-labeling--variant-icons-legacy': this.layoutVariant === 'icons-legacy',
      'brandhub-co2-labeling--variant-icons': this.layoutVariant === 'icons',
      'brandhub-co2-labeling--variant-text': this.layoutVariant === 'text',
      'brandhub-co2-labeling--variant-text-large': this.layoutVariant === 'text-large',
      'brandhub-co2-labeling--has-entries': this.hasEntries,
      'brandhub-co2-labeling--has-text': this.hasText,
    };
  }

  get labelingInformation (): LabelingInfo[] {
    return this.labelingJson
      ? JSON.parse(this.labelingJson)
      : [{
        modelName: this.modelName,
        testProcedure: this.testProcedure,
        fuelConsumption: this.fuelConsumption,
        fuelPollution: this.fuelPollution,
        energyConsumption: this.energyConsumption,
        labelingText: this.labelingText,
      }];
  }

  get labelingInformationWithValues (): LabelingInfo[] | null {
    return this.labelingInformation
      ? this.labelingInformation.filter((info: LabelingInfo) => !!(info.fuelConsumption || info.fuelPollution || info.energyConsumption))
      : null;
  }

  get labelingInformationWithText (): LabelingInfo[] | null {
    if (!this.labelingInformation) {
      return null;
    }
    const renderedTexts: string[] = [];
    return this.labelingInformation.filter((info: LabelingInfo) => {
      if (!info.labelingText) {
        return false;
      }
      if (renderedTexts.includes(info.labelingText)) { // render same text only once
        return false;
      }
      renderedTexts.push(info.labelingText);
      return true;
    });
  }

  get hasEntries () {
    return this.labelingInformationWithValues && this.labelingInformationWithValues.length > 0;
  }

  get hasText () {
    return this.labelingInformationWithText && this.labelingInformationWithText.length > 0;
  }

  get hasLabeling () {
    return !!(this.labelingJson || this.labelingText || this.fuelConsumption || this.fuelPollution || this.energyConsumption);
  }
}
